<template>
  <div>
    <Dashboard/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Dashboard from '@/views/Dashboard/Dashboard.vue';

export default {
  name: 'Main',
  components: { Dashboard },
  data: () => ({
    warning: false,
    CO_BRANDED_PAGE_ACCESS: { resource: 'co-branded', code: 'access' },
  }),
  computed: {
    ...mapGetters(['isSwitched', 'userAuthenticator']),
    ...mapState('contractor', { hasPage: (state) => state.hasPage }),
  },
  watch: {
    hasPage(value) {
      this.warning = (value === null) ? false : !value;
    },
  },
};
</script>

<style lang="stylus">
</style>
